import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { ArrowLeft } from "lucide-react";

export default function CollectionPage() {
  const { slug } = useParams();
  const [collection, setCollection] = useState(null);

  useEffect(() => {
    api.get(`/collections/${slug}`).then(({ data }) => setCollection(data)).catch(() => setCollection(false));
  }, [slug]);

  if (collection === null) return <div className="min-h-[60vh] flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (collection === false) return <div className="min-h-[60vh] flex items-center justify-center text-muted-foreground">Collection not found.</div>;

  return (
    <div data-testid="collection-page">
      {/* Hero */}
      <section className="relative">
        <div className="aspect-[21/9] lg:aspect-[21/8] max-h-[600px] overflow-hidden bg-secondary">
          <img
            src={collection.hero_image || collection.products?.[0]?.images?.[0]}
            alt={collection.title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground/70 via-foreground/20 to-transparent" />
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-8 lg:p-16 text-background">
          <div className="max-w-7xl mx-auto">
            <Link to="/shop" className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase opacity-80 hover:opacity-100 mb-6">
              <ArrowLeft className="w-3.5 h-3.5" /> All collections
            </Link>
            <div className="text-xs tracking-[0.3em] uppercase text-primary font-semibold mb-3">◦ Curated Collection</div>
            <h1 className="font-serif text-5xl lg:text-7xl tracking-tight font-medium leading-[1.05] max-w-3xl">
              {collection.title}
            </h1>
            {collection.subtitle && (
              <p className="mt-6 max-w-xl text-base lg:text-lg opacity-90 leading-relaxed">{collection.subtitle}</p>
            )}
          </div>
        </div>
      </section>

      {/* Products */}
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="text-xs tracking-[0.3em] uppercase text-primary font-semibold mb-2">◦ The Chapter</div>
        <div className="flex items-end justify-between mb-12">
          <h2 className="font-serif text-3xl lg:text-4xl tracking-tight">{collection.products?.length || 0} hand-picked pieces.</h2>
        </div>
        {(!collection.products || collection.products.length === 0) ? (
          <div className="text-muted-foreground italic">This chapter is being curated.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {collection.products.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </section>
    </div>
  );
}
